import { render, staticRenderFns } from "./SocialMediaCampaign.vue?vue&type=template&id=58d69888&scoped=true&"
import script from "./SocialMediaCampaign.vue?vue&type=script&lang=js&"
export * from "./SocialMediaCampaign.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaCampaign.vue?vue&type=style&index=0&id=58d69888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d69888",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VBtn,VCol,VIcon,VImg,VRow,VSlideGroup,VSlideItem})
